import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { UserUrl } from '../../../shared/urls/user.url';
@Injectable()
export class AssignUserService {
    constructor(public baseService: BaseService) {
    }

    getUnAssignedUserList(param) {
        const url = UserUrl.GET_UNASSIGNED_CENTRE_USERS;
        return this.baseService.getData(url, param);
    }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/assign-user/assign-user.service.ts